import { BrokerMandateSignatureDataModel } from './broker-mandate-signature.model';

export class BrokerMandateSignaturesResponseModel {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  data: BrokerMandateSignatureDataModel[];
}
